import * as React from "react";
const SvgAlignHorizontalLeftOutlined = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M4 22H2V2h2v20zM22 7H6v3h16V7zm-6 7H6v3h10v-3z" />
  </svg>
);
export default SvgAlignHorizontalLeftOutlined;
